// DO NOT MODIFY - this file is auto-generated by build-icons.js
// @ts-nocheck
import React from 'react';
import Icon from '../shared/icon';

/* eslint-disable react/jsx-max-props-per-line,react/jsx-space-before-closing,react/jsx-tag-spacing */

const ChevronLeftIcon = (props) => (
  <Icon {...props}>
    {
      ({ color, width, height }) => (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 13 20">
          <path fill="inherit" d="M10.539 0c.486 0 .962.147 1.367.421.405.275.72.666.907 1.122a2.536 2.536 0 0 1-.534 2.725L6.635 10l5.644 5.732A2.52 2.52 0 0 1 13 17.5a2.52 2.52 0 0 1-.72 1.768 2.443 2.443 0 0 1-1.741.732 2.443 2.443 0 0 1-1.741-.732l-7.385-7.5a2.534 2.534 0 0 1 0-3.536l7.385-7.5A2.42 2.42 0 0 1 10.538 0z" />
        </svg>
      )
    }
  </Icon>
);

export default ChevronLeftIcon;
